import React from "react";
import {
  FooterContainer,
  SocialMedia,
  SocialMediaWrap,
  SocialLogo,
  SocialIcon,
  WebsiteRights,
  SocialIcons,
  SocialIconLink,
} from "./Footer.elements";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <FooterContainer>
      <SocialMedia>
        <SocialMediaWrap>
          <SocialLogo>
            <SocialIcon aria-hidden="true" />
            Peragal Tech
          </SocialLogo>
          <WebsiteRights>Peragal Tech © {year}. Build better, ship faster.</WebsiteRights>
          <SocialIcons>
            <SocialIconLink href="mailto:peragaltech@peragaltech.com" aria-label="Email Peragal Tech">
              peragaltech@peragaltech.com
            </SocialIconLink>
          </SocialIcons>
        </SocialMediaWrap>
      </SocialMedia>
    </FooterContainer>
  );
};

export default Footer;
